import { LineItem } from 'shared/types/cart';
import { Variant } from 'shared/types/product';

export const TEMP_ATTRIBUTE_FOR_BUNDLE = 'bundles';

export const getBundleSlugToAttributes = (productTypeKey?: string): Record<string, string> | null => {
  switch (productTypeKey) {
    case 'subscription':
        // TODO: read from projectSettings.bundlesAndSubscriptionConfig
      return { 'subscription_interval_days': 'Repeat' };
    case 'ebook':
      return { 'sku': 'SKU' };
    case 'physical-book':
      return { 'sku': 'SKU' };
    default:
      return null;
  }
};
export const bundleSlugToEmptyLabel: Record<string, string> = {

};

const getLabel = (value: Record<string, string> | string | boolean) => {
  if (value === true) {
    return 'Y';
  }
  if (value === false) {
    return 'N';
  }
  if (typeof value === 'object') {
    return value.label || value['en-GB'] || value['en-US'];
  }
  return typeof value === 'undefined' ? '' : value;
};

export const getSelectedBundleLabel = (variant?: Variant, productTypeKey?: string): string => {
  const bundleItemAttributes = getBundleSlugToAttributes(productTypeKey);
  if (bundleItemAttributes) {
    return Object.keys(bundleItemAttributes)
      .map((attribute) => `${bundleItemAttributes[attribute]} ${getLabel(variant?.attributes?.[attribute])}`)
      .join(', ');
  }
  return productTypeKey || '';
};

export const getEmptyLabel = (name?: string) => {
  return bundleSlugToEmptyLabel[name || 'None'];
};

export const bundleItems = (lineItems: (LineItem & { custom: any })[]): (LineItem & { custom: any })[] => {
    const bundles = lineItems?.filter((item) => !!item?.parentLineItemKey);
    const items = lineItems?.filter((item) => !item?.parentLineItemKey);

    return items?.map((item) => {
      const itemBundles = bundles?.filter((bundle) => bundle?.parentLineItemKey === item.key);
      if (item.variant?.attributes && itemBundles?.length) {
        item.variant.attributes[TEMP_ATTRIBUTE_FOR_BUNDLE] = [];
        itemBundles?.forEach((bundle) => {
          // @ts-ignore
          item.variant?.attributes[TEMP_ATTRIBUTE_FOR_BUNDLE].push(bundle);
        });
      }

      return item;
    });
  };




